export default __webpack_public_path__ + "assets/images/12dea129ecb87ab60439f318567b524e.jpg";